import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, ImagePlus, Loader2 } from 'lucide-react';
import { salesApi, apiError, compressImage } from '../../salesApi';
import { useT } from '../../salesI18n';

// Upload de fotos (galeria + câmera) com compressão no cliente. onUploaded(fileDoc) por foto.
export const PhotoUploader = ({ leadId, kind = 'exterior', openingId, multiple = true, onUploaded, compact = false }) => {
  const { t } = useT();
  const galleryRef = useRef(null);
  const cameraRef = useRef(null);
  const [progress, setProgress] = useState(null); // {done, total}

  const handleFiles = async (fileList) => {
    const files = Array.from(fileList || []).filter((f) => f.type.startsWith('image/'));
    if (!files.length) return;
    setProgress({ done: 0, total: files.length });
    for (let i = 0; i < files.length; i += 1) {
      try {
        const compressed = await compressImage(files[i]);
        const fd = new FormData();
        fd.append('file', compressed);
        fd.append('kind', kind);
        if (openingId) fd.append('opening_id', openingId);
        const { data } = await salesApi.post(`/leads/${leadId}/photos`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        onUploaded?.(data);
      } catch (e) {
        toast.error(apiError(e));
      }
      setProgress({ done: i + 1, total: files.length });
    }
    setProgress(null);
    if (galleryRef.current) galleryRef.current.value = '';
    if (cameraRef.current) cameraRef.current.value = '';
  };

  const busy = Boolean(progress);
  const btn = compact
    ? 'inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-border text-xs font-semibold hover:bg-accent transition-colors disabled:opacity-60'
    : 'inline-flex items-center justify-center gap-2 h-11 px-4 rounded-lg text-sm font-semibold transition-colors disabled:opacity-60';

  return (
    <div className={`flex flex-wrap gap-2 ${compact ? '' : 'items-center'}`} data-testid="photo-uploader">
      <input ref={galleryRef} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={(e) => handleFiles(e.target.files)} data-testid="photo-uploader-input" />
      <input ref={cameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => handleFiles(e.target.files)} data-testid="photo-uploader-camera-input" />
      <button type="button" disabled={busy} onClick={() => galleryRef.current?.click()} className={`${btn} ${compact ? '' : 'bg-primary text-primary-foreground hover:bg-primary/90'}`} data-testid="photo-uploader-gallery-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}
        {busy ? `${t.uploading} ${progress.done}/${progress.total}` : t.addPhotos}
      </button>
      <button type="button" disabled={busy} onClick={() => cameraRef.current?.click()} className={`${btn} ${compact ? '' : 'border border-border hover:bg-accent'} sm:hidden`} data-testid="photo-uploader-camera-btn">
        <Camera className="h-4 w-4" /> {t.takePhoto}
      </button>
    </div>
  );
};
